function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { getCategoryByProvider, getProductTypeLabel } from '@finect/front-resources/Products';
import { isBrowser } from '@finect/front-utils/isBrowser';
import { getProductTypeByAPISubtype } from '../../Products/utils';
import { Section } from '../../Section';
import { FundScatterComparison } from '../../Products/Charts';
import { Select } from '../../Select';
import { Tabs } from '../../Tabs';
import { fetchFunds } from './actions';
import { getInitialAxis } from './utils';
import { axisDimensions, universes, axis } from './data';
import { DetailCard } from './DetailCard';
import { SelectorsBlock, SelectorBlock } from './partials';
export var FundScatterComparisonChart = function (_React$Component) {
  _inherits(FundScatterComparisonChart, _React$Component);
  var _super = _createSuper(FundScatterComparisonChart);
  function FundScatterComparisonChart() {
    var _this;
    _classCallCheck(this, FundScatterComparisonChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      fetching: false,
      fetched: false,
      funds: [],
      xAxis: getInitialAxis(_this.props.contextFunds, _this.props.xAxisPreference, 'ogc'),
      yAxis: getInitialAxis(_this.props.contextFunds, _this.props.yAxisPreference, 'r36'),
      universe: _this.props.universes.length ? _this.props.universes[0] : 'sameCategory',
      compareWith: null,
      request: {}
    });
    _defineProperty(_assertThisInitialized(_this), "fetchData", function (request) {
      var yAxis = _this.state.yAxis;
      var getOrderBy = function getOrderBy() {
        if (yAxis && yAxis.value && yAxis.value.dimension === 'performance') {
          return "-performance/".concat(yAxis.value.period);
        }
      };
      var order = getOrderBy();
      var orderby = order ? order : '-performance/M120';
      var requestWithOrder = _objectSpread(_objectSpread({}, request), {}, {
        orderby: orderby
      }, _this.props.products ? {
        products: _this.props.products
      } : {});
      _this.setState({
        fetching: true,
        fetched: false,
        funds: [],
        request: requestWithOrder
      }, function () {
        fetchFunds(requestWithOrder).then(function (funds) {
          _this.setState({
            funds: funds,
            fetching: false,
            fetched: true
          });
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getProductSubtype", function () {
      return _this.props.contextFunds[0] ? _this.props.contextFunds[0].subtype : null;
    });
    _defineProperty(_assertThisInitialized(_this), "getStorefront", function () {
      var tags = _this.props.contextFunds.map(function (_ref) {
        var socialStats = _ref.socialStats;
        return socialStats.tags;
      }).flatMap(function (tag) {
        return tag;
      });
      var storefront = tags.find(function (_ref2) {
        var alias = _ref2.alias;
        return _this.props.storefront === alias;
      });
      return storefront;
    });
    _defineProperty(_assertThisInitialized(_this), "handleXAxisChange", function (value) {
      _this.setState({
        xAxis: axisDimensions.find(function (item) {
          return item.id === value.id;
        })
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleYAxisChange", function (value) {
      _this.setState({
        yAxis: axisDimensions.find(function (item) {
          return item.id === value.id;
        })
      }, function () {
        _this.fetchData(_this.state.request);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleUniverseChange", function (value) {
      var contextFunds = _this.props.contextFunds;
      var productType = getProductTypeByAPISubtype(_this.getProductSubtype(), _this.props.theme);
      var category = contextFunds && contextFunds.length ? getCategoryByProvider(contextFunds[0].categories, 'MS') : null;
      var managementCompany = contextFunds && contextFunds.length ? contextFunds[0].managementCompany : null;
      var tags = _this.props.contextFunds.map(function (_ref3) {
        var socialStats = _ref3.socialStats;
        return socialStats.tags;
      }).flatMap(function (tag) {
        return tag;
      });
      var srris = _this.props.contextFunds.map(function (_ref4) {
        var srri = _ref4.srri;
        return srri;
      }).flatMap(function (item) {
        return item;
      });
      var storefront = tags.find(function (_ref5) {
        var alias = _ref5.alias;
        return _this.props.storefront === alias;
      });
      _this.setState({
        universe: value.id
      }, function () {
        _this.fetchData({
          productType: productType,
          universe: value.id,
          managementCompany: managementCompany,
          category: category,
          storefront: {
            id: storefront ? storefront.id : null
          },
          srri: srris
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOver", function (id) {
      if (!_this.props.withTooltip || !id) return;
      var fund = _this.state.funds.find(function (item) {
        return item.id === id;
      });
      if (fund && window && window.innerWidth >= 1440) {
        _this.setState({
          compareWith: fund
        });
      }
    });
    return _this;
  }
  _createClass(FundScatterComparisonChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        theme = _this$props.theme,
        contextFunds = _this$props.contextFunds;
      var productType = getProductTypeByAPISubtype(this.getProductSubtype() || 'fund', theme);
      var category = contextFunds[0].category;
      var request = {
        productType: productType,
        universe: this.state.universe
      };
      if (this.props.storefront) {
        request.storefront = {
          id: this.props.storefront
        };
      }
      var storefront = this.getStorefront();
      if (storefront) {
        request.storefront = {
          id: storefront.id
        };
      }
      if (category) {
        request.category = category;
      }
      this.fetchData(_objectSpread({}, request));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (prevProps.products !== this.props.products) {
        this.setState({
          funds: []
        }, function () {
          _this2.fetchData(_this2.state.request);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        bottomMargin = _this$props2.bottomMargin,
        theme = _this$props2.theme,
        contextFunds = _this$props2.contextFunds,
        withTitle = _this$props2.withTitle;
      var _this$state = this.state,
        xAxis = _this$state.xAxis,
        yAxis = _this$state.yAxis,
        compareWith = _this$state.compareWith;
      if (!xAxis || !yAxis) return 'Error';
      if (!isBrowser() || !contextFunds.length) return React.createElement(Fragment, null, "Cargando...");
      var productType = getProductTypeByAPISubtype(this.getProductSubtype(), theme);
      var chartKey = "chart-".concat(xAxis.id).concat(yAxis.id).concat(this.state.universe);
      var fund = contextFunds[0];
      var storefront = this.getStorefront();
      var tabs = universes.filter(function (universe) {
        return _this3.props.universes.includes(universe.id);
      }).filter(function (_ref6) {
        var id = _ref6.id;
        return !['storefront'].includes(id);
      }).map(function (_ref7) {
        var id = _ref7.id,
          label = _ref7.label;
        return {
          id: id,
          title: label
        };
      });
      var newTabs = [].concat(_toConsumableArray(storefront ? [{
        id: 'storefront',
        title: storefront.name
      }] : []), _toConsumableArray(tabs));
      var title = this.props.title ? this.props.title : withTitle ? "Comparar con otros ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase')) : '';
      return React.createElement(Section, {
        title: title,
        subtitle: this.props.subtitle || '',
        subtitleVariant: this.props.subtitleVariant,
        bottomMargin: bottomMargin || false
      }, compareWith ? React.createElement(DetailCard, {
        productType: productType,
        funds: [fund, compareWith || fund]
      }) : null, this.props.withUniversesTabs && React.createElement(Tabs, {
        selected: this.state.universe,
        onChange: this.handleUniverseChange,
        tabs: newTabs
      }), React.createElement(FundScatterComparison, {
        key: chartKey,
        axis: axis,
        productType: productType,
        funds: this.state.funds,
        contextFunds: contextFunds,
        colors: this.props.colors,
        sizes: this.props.sizes,
        xAxis: xAxis,
        yAxis: yAxis,
        fetching: this.state.fetching,
        fetched: this.state.fetched,
        onHover: this.handleOver
      }), React.createElement(SelectorsBlock, null, React.createElement(SelectorBlock, {
        vertical: true
      }, React.createElement(Select, {
        vertical: true,
        withBorder: false,
        withPadding: false,
        selected: yAxis.id,
        onChange: this.handleYAxisChange,
        minWidth: 300,
        options: axisDimensions,
        placeholder: axis.yAxis.label
      })), React.createElement(SelectorBlock, null, React.createElement(Select, {
        vertical: false,
        withBorder: false,
        withPadding: false,
        selected: xAxis.id,
        onChange: this.handleXAxisChange,
        minWidth: 300,
        options: axisDimensions,
        placeholder: axis.xAxis.label
      }))));
    }
  }]);
  return FundScatterComparisonChart;
}(React.Component);
_defineProperty(FundScatterComparisonChart, "defaultProps", {
  contextFunds: [],
  withTitle: true,
  withTooltip: true,
  universes: ['sameCategory', 'sameManagementCompany', 'mostViewed'],
  withUniversesTabs: true,
  yAxisPreference: ['r120', 'r36', 'r12'],
  xAxisPreference: ['ogc', 'sd120', 'sd36', 'sd12']
});
export default withTheme(FundScatterComparisonChart);